import { Suspense, useState, useEffect } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import PageLoader from "../components/common/PageLoader";
import { SessionWarning } from "../components/common/SessionWarning";
import { useStorageSync } from "../hooks/useStorageSync";
import { useTokenRefresh } from "../hooks/useTokenRefresh";
import { Header } from "./Header/Header";
import { Sidebar } from "./Menu/Sidebar";

export default function MainLayout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const location = useLocation();
  const outlet = useOutlet();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    let title = 'Maleva';

    if (path.includes('planning/view') || path.includes('planing/view')) {
      title = 'PLANNING VIEW';
    } else if (path.includes('planning') || path.includes('planing')) {
      title = 'PLANNING';
    } else if (path.includes('sale-order/view')) {
      title = 'SALE ORDER VIEW';
    } else if (path.includes('sale-order') || path.includes('saleorder')) {
      title = 'SALE ORDER';
    } else if (path.includes('sale-invoice/view')) {
      title = 'SALE INVOICE VIEW';
    } else if (path.includes('sale-invoice')) {
      title = 'SALE INVOICE';
    } else if (path.includes('rti/view')) {
      title = 'RTI VIEW';
    } else if (path.includes('rti')) {
      title = 'RTI';
    } else if (path.includes('vessel-planning/view')) {
      title = 'VESSEL PLANNING VIEW';
    } else if (path.includes('vessel-planning')) {
      title = 'VESSEL PLANNING';
    } else if (path.includes('paymentvoucher/view')) {
      title = 'PAYMENT VOUCHER VIEW';
    } else if (path.includes('paymentvoucher')) {
      title = 'PAYMENT VOUCHER';
    } else if (path.includes('bills/view')) {
      title = 'BILLS VIEW';
    } else if (path.includes('bills')) {
      title = 'BILLS';
    } else if (path.includes('report/prealertrerport')) {
      title = 'PRE-ALERT REPORT';
    } else if (path.includes('dashboard')) {
      title = 'DASHBOARD';
    } else {
      const segment = path.split('/')[1];
      if (segment) {
        title = segment.replace(/-/g, ' ').toUpperCase();
      }
    }

    document.title = title ? `${title} - Maleva` : 'Maleva';
  }, [location.pathname]);

  useStorageSync();

  const { refreshToken } = useTokenRefresh();

  const handleRefreshSession = async () => {
    try {
      await refreshToken();
    } catch (error) {
      console.error("Manual refresh failed:", error);
    }
  };

  // h-dvh, not h-screen: on iPad Safari 100vh includes the area behind the browser bars,
  // so the last rows of full-height grids were hidden below the visible screen. Browsers
  // without dvh support keep h-screen.
  return (
    <div className="h-screen supports-[height:100dvh]:h-dvh flex flex-col overflow-hidden" style={{ backgroundColor: "#F7F9FC" }}>
      <Header />

      <div className="flex flex-1 min-h-0">
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggle={() => setIsSidebarCollapsed((previous) => !previous)}
        />

        <main
          key={location.key ?? location.pathname}
          className="flex-1 overflow-y-auto min-h-0 overscroll-contain safe-bottom"
        >
          <Suspense fallback={<PageLoader />}>{outlet}</Suspense>
        </main>
      </div>

      <SessionWarning onRefresh={handleRefreshSession} />
    </div>
  );
}
